/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Audio_Minute_OtherInputs */

const en_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} audio minutes`)
};

const zh_hans1_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 分钟音频`)
};

const pt_br2_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutos de áudio`)
};

const es_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutos de audio`)
};

const fr_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutes audio`)
};

const de_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Audiominuten`)
};

const ru_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Минут аудио: ${i?.count}`)
};

const it_measure_unit_audio_minute_other = /** @type {(inputs: Measure_Unit_Audio_Minute_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minuti di audio`)
};

/**
* | output |
* | --- |
* | "{count} audio minutes" |
*
* @param {Measure_Unit_Audio_Minute_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_audio_minute_other = /** @type {((inputs: Measure_Unit_Audio_Minute_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Audio_Minute_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_audio_minute_other(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_audio_minute_other(inputs)
	if (locale === "es") return es_measure_unit_audio_minute_other(inputs)
	if (locale === "fr") return fr_measure_unit_audio_minute_other(inputs)
	if (locale === "de") return de_measure_unit_audio_minute_other(inputs)
	if (locale === "ru") return ru_measure_unit_audio_minute_other(inputs)
	if (locale === "it") return it_measure_unit_audio_minute_other(inputs)
	return en_measure_unit_audio_minute_other(inputs)
});